module.exports = __webpack_public_path__ + "img/94-c1d505.png";